import React, {useState, useEffect} from 'react'
import AuthContext from '../../context/AuthProvider'
import { useContext } from "react"
import {useNavigate} from 'react-router-dom'
import MaterialTable from "material-table";
import {Modal, TextField, Button, Collapse } from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add'
import VisibilityIcon from '@mui/icons-material/Visibility';
import CircularProgress from '@mui/material/CircularProgress';
import { data as newData } from '../../constants';

// import AddIcon from '@mui/icons-material/Add';
// import Box from '@mui/material/Box';
// import LinearProgress from '@mui/material/LinearProgress';
// import axios, { axiosPrivate } from '../../axios' 
// import {dni, validarCodigoDni} from '../../constants/dni'

import useAxiosPrivate from '../../hooks/useAxiosPrivate';



import './patients.scss'
import { validarCodigoDni } from '../../constants/dni';
// import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

const PATIENTS_URL = '/patients';
const UPLOAD_URL = '/photop';

const useStyles = makeStyles((theme) => ({
  modal: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    ['@media (max-width:480px)']: { // eslint-disable-line no-useless-computed-key
      width: 230
    }
  },
  
  // modall:{
  //   position: 'absolute',
  //   width: 600,
  //   backgroundColor: theme.palette.background.paper,
  //   border: '2px solid #000',
  //   boxShadow: theme.shadows[5],
  //   padding: theme.spacing(2, 4, 3),
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%)'
  // },
  iconos:{
    cursor: 'pointer'
  }, 
  inputMaterial:{
    width: '100%'
  }
}));

const Patients = () => {
  const [fotoDesplegado, setFotoDesplegado] = useState(false);
  const [mostrarFoto, setMostrarFoto] = useState(false);
  // Resto de tu código...

  // Función para mostrar u ocultar la foto
    // Función para mostrar u ocultar la foto
  const toggleFotoDesplegado = () => {
      setFotoDesplegado(!fotoDesplegado);
    };
  const toggleMostrarFoto = () => {
    setMostrarFoto(!mostrarFoto);
  };
  const contexto = useContext(AuthContext)
  const axiosPrivate = useAxiosPrivate();

  // const [imageUrl, setImageUrl] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  const history = useNavigate()

  const styles= useStyles();
  const [data, setData]= useState([]);
  const [modalInsertar, setModalInsertar]= useState(false);
  const [modalEditar, setModalEditar]= useState(false);
  const [modalEliminar, setModalEliminar]= useState(false);
  const [modalVer, setModalVer]= useState(false);

  const getCurrentDate = () =>{
    let today = new Date();
    let month = today.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let days = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
  
    today = today.getFullYear() + "-" + month + "-" + days;
  
    console.log(today);
    return today
  }
  const [patient, setPatient]=useState({
    nombre: "",
    celular: "",
    _id: "",
    ci: "",
    direccion: "",
    alergias:"",
    fecha:"",
    edad:"",
    photo:""

  })
  
  const initialState = {
    nombre: "",
    celular: "",
    _id: "",
    ci: "",
    direccion: "",
    alergias:"Ninguna",
    fecha: getCurrentDate(),
    edad:"",
    photo:""
   
  }
  const columns= [
    { title: "N°", render: rowData => rowData.tableData.id + 1, width: "4%" },
    { title: 'Nombre/Paciente', field: 'nombre' },
    { title: validarCodigoDni(contexto.auth.phone), field: 'ci' },
    { title: 'Alergias', field: 'alergias' },
    { title: 'Edad', field: 'edad'},
    { title: 'Fecha', field: 'fecha'},
    // { title: 'Estado', field: 'direccion', type: 'numeric'}    
  ];
  // const handleChange=e=>{
  //   console.log(patient)
  //   const {name, value}=e.target;
  //   setPatient(prevState=>({
  //     ...prevState,
  //     [name]: value
  //   }));
  // }
  const handleChange=e=>{
    console.log(patient)

    if(e.target.type === 'checkbox'){
      let checkboxValue = e.target.checked ? "checked": ""
      console.log(checkboxValue)
      setPatient(prevState =>({
          ...prevState,
         [e.target.name]: checkboxValue
      }))

    }
    else {
          const {name, value}=e.target;
          setPatient(prevState=>({
            ...prevState,
            [name]: value
          }));
           
    }

 
    }
  

  const peticionGet=async()=>{
    await axiosPrivate.get(PATIENTS_URL)
    .then(response=>{
    console.log(response)
    // response.data[0] 
     setData(response.data);
    }).catch(error=>{
      console.log(error);
    })
  }


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };
  const handleUpload = (id) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('image', selectedFile);
        
        axiosPrivate
            .put(`${UPLOAD_URL}/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                console.log(response.data.imageUrl);
                // Puedes hacer más cosas aquí si es necesario
                resolve(response.data.imageUrl);
            })
            .catch((error) => {
                console.error('Error uploading image: ', error);
                reject(error);
            });
    });
};

const peticionPost = async () => {
  try {
      // Realizar la petición POST para agregar el paciente
      const response = await axiosPrivate.post(PATIENTS_URL, patient);
      const newPatient = response.data;

      // Verificar si hay una imagen seleccionada antes de subirla
      if (selectedFile) {
          // Subir la imagen y obtener la URL solo si hay una imagen seleccionada
          await handleUpload(newPatient._id);
      }

      // Actualizar la lista de pacientes con los nuevos datos y la nueva URL de la imagen
      setData(prevData => [...prevData, newPatient]);

      abrirCerrarModalInsertar();

      history(`/detail/${newPatient._id}`);
      // window.location.reload();

  } catch (error) {
      console.log(error);
  }
};

const peticionPut = async () => {
  try {
      // Verificar si hay una imagen seleccionada antes de subirla
      let imageUrl = patient.photo; // Por defecto, usa la URL actual de la imagen

      if (selectedFile) {
          // Subir la imagen y obtener la URL solo si hay una imagen seleccionada
          imageUrl = await handleUpload(patient._id);
      }

      // Actualizar los datos del paciente con la nueva URL de la imagen
      const response = await axiosPrivate.put(PATIENTS_URL + "/" + patient._id, {
          ...patient,
          photo: imageUrl, // Actualizar la URL de la imagen
      });

      console.log('ME EJECUTO PUT');
      console.log(response.data);

      // Actualizar la lista de pacientes con los nuevos datos y la nueva URL de la imagen
      const dataNueva = data.map(artista => {
          if (artista._id === patient._id) {
              return {
                  ...artista,
                  nombre: patient.nombre,
                  celular: patient.celular,
                  direccion: patient.direccion,
                  ci: patient.ci,
                  edad: patient.edad,
                  fecha: patient.fecha,
                  alergias: patient.alergias,
                  photo: imageUrl, // Actualizar la URL de la imagen
              };
          }
          return artista;
      });

      console.log(dataNueva);
      setData(dataNueva);
      abrirCerrarModalEditar();

  } catch (error) {
      console.log(error);
  }
};




  const peticionDelete=async()=>{
    console.log(patient._id)
    await axiosPrivate.delete(PATIENTS_URL+"/"+patient._id)
  
    .then(response=>{
      setData(data.filter(artista=>artista._id!==patient._id));
      abrirCerrarModalEliminar();
 
      // window.location.reload();
    
    }).catch(error=>{
      console.log(error);
    })
  }


 const detallePaciente = (artista) =>{
    console.log(artista._id)
    history(`/detail/${artista._id}`)
 }




  const seleccionarArtista=(artista, caso)=>{
    setPatient(artista);
    if(caso==="Editar"){
      //reseteamos el estado 
      setSelectedFile(null);

      abrirCerrarModalEditar()
    }
    else if(caso==="Ver"){
      abrirCerrarModalVer()
    }
    else if(caso==="Eliminar"){
      abrirCerrarModalEliminar()
    }

  }

  const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
    //reinitializing
    setPatient(initialState)
  }

  
  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }

  const abrirCerrarModalVer = () =>{
    setModalVer(!modalVer)
  }

  useEffect(()=>{
    peticionGet()
  }, [])

  const bodyInsertar=(
    <div className="insertarHome">
      <h3>Agregar Nuevo Paciente</h3>
      <TextField className={styles.inputMaterial} label="Nombre" name="nombre" onChange={handleChange} />
      <br />
      <TextField className={styles.inputMaterial} label={validarCodigoDni(contexto.auth.phone)} type="number" name="ci" onChange={handleChange}/>          
      <br />
      <TextField className={styles.inputMaterial} label="Alergias / Enfermedades" name="alergias" value={patient&&patient.alergias} onChange={handleChange} />          
      <br />
      <TextField className={styles.inputMaterial} label="Celular" type='number' name="celular" onChange={handleChange}/>
      <br />
      <TextField className={styles.inputMaterial} label="Edad" name="edad" type="number" onChange={handleChange}/>
      <br />
      <TextField className={styles.inputMaterial} label="Dirección" name="direccion" onChange={handleChange}/>
      <br />
      <br />
      <TextField type='date' className={styles.inputMaterial}  name="fecha" onChange={handleChange} value={patient&&patient.fecha}/>
      <br />
      <br />
      <div>
        <Button startIcon={<AddIcon />} variant="text" onClick={toggleFotoDesplegado} style={{ cursor: 'pointer' }}>
         Foto 
        </Button>
        <Collapse in={fotoDesplegado}>
          <div className="file-upload">
            <label htmlFor="fileInput" className="custom-square">
              {selectedFile ? (
                <img src={URL.createObjectURL(selectedFile)} alt="Selected" />
              ) : (
                <span>Seleccionar Imagen</span>
              )}
              <input type="file" id="fileInput" onChange={handleFileChange} />
            </label>
          </div>
        </Collapse>
      </div>
   
 
      {/* <DateTimePicker
        /> */}

      <div align="right">
        <Button color="primary" onClick={()=>peticionPost()}>Insertar</Button>
        <Button onClick={()=>abrirCerrarModalInsertar()}>Cancelar</Button>
      </div>
    </div>
  )

  const bodyEditar=(
    <div className="insertarHome">
      <h3>Editar Paciente</h3>
      <TextField className={styles.inputMaterial} label="Paciente" name="nombre"  onChange={handleChange} value={patient&&patient.nombre}/>
      <br />
      <TextField className={styles.inputMaterial} label={validarCodigoDni(contexto.auth.phone)} name="ci" onChange={handleChange} value={patient&&patient.ci}/>          
      <br />
      <TextField className={styles.inputMaterial} label="Alergias / Enfermedades" name="alergias" onChange={handleChange} value={patient&&patient.alergias}/>          
      <br />
      <TextField className={styles.inputMaterial} label="Celular" name="celular" onChange={handleChange} value={patient&&patient.celular}/>
      <br />
      <TextField className={styles.inputMaterial} label="Dirección" name="direccion" onChange={handleChange} value={patient&&patient.direccion}/>
       <br />
      <TextField className={styles.inputMaterial} label="Edad" name="edad" onChange={handleChange} value={patient&&patient.edad}/>
      <br />
      <br />
      <TextField className={styles.inputMaterial} type="date" name="fecha" onChange={handleChange} value={patient&&patient.fecha}/>
            
      <br /><br />
      <div className="image-preview">
        {/* <h4>Foto:</h4> */}
        {/* <button onClick={toggleMostrarFoto}>
          {mostrarFoto ? 'Ocultar Foto' : 'Mostrar Foto'}
        </button> */}

        <Button startIcon={<VisibilityIcon />} color="primary" variant="text" onClick={toggleMostrarFoto}>
        {mostrarFoto ? 'Ocultar Foto' : 'Mostrar Foto'}
        </Button>
       
        {mostrarFoto && (
          <div>
            <div className="image-preview">
              <img src={`${newData.urls.urlUpload}${patient.photo}`} alt="Uploaded" />
            </div>
            <div>
        <h4>Cambiar Foto:</h4>
            <div className="file-upload">
              <label htmlFor="fileInput" className="custom-square">
                {selectedFile ? (
                  <img src={URL.createObjectURL(selectedFile)} alt="Selected" />
                ) : (
                  <span>Seleccionar Imagen</span>
                )}
                <input type="file" id="fileInput" onChange={handleFileChange} />
              </label>
              {/* <button className="upload-button" onClick={handleUpload(patient._id)}>
                Subir Imagen
              </button> */}
            </div>
          </div> 
          </div>
        )}
        </div>


      <div align="right">
        <Button color="primary" onClick={()=>peticionPut()}>Editar</Button>
        <Button onClick={()=>abrirCerrarModalEditar()}>Cancelar</Button>
      </div>
    </div>
  )

  const bodyEliminar=(
    <div className={styles.modal}>
      <p>Estás seguro que deseas eliminar al paciente: <b>{patient && patient.nombre}</b>? </p>
      <div align="right">
        <Button color="secondary" onClick={()=>peticionDelete()}>Sí</Button>
        <Button onClick={()=>abrirCerrarModalEliminar()}>No</Button>

      </div>

    </div>
  )

    return ( 
      <div className='patients'>  

           
        <br />
        <Button className="insertar" onClick={() => { abrirCerrarModalInsertar(); setSelectedFile(null); }}>
          <AddIcon /> Nuevo Paciente
        </Button>
        <br /><br />
       <div>
       {/* <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>  */}

       <MaterialTable     
          
          columns={columns}
          data={data} 
          title= "Lista de Pacientes"
          actions={[
            {
              icon: 'visibility',
              tooltip: 'Editar Paciente',
              iconProps: { style: {color: "#111B21"} },
              
              onClick: (event, rowData) => seleccionarArtista(rowData, "Editar")
            },
            {
              icon: 'delete',
              tooltip: 'Eliminar Paciente',
              iconProps: { style: { color: "#F24E4F"} },
              onClick: (event, rowData) => seleccionarArtista(rowData, "Eliminar")
            },
           
            // {
            //   icon: 'visibility',
            //   tooltip: 'Ver detalles',
            //   onClick: (event, rowData) => seleccionarArtista(rowData, "Ver")
            // },
            {
              icon: 'assignment',
              iconProps: { style: { color: "#111B21"} },
              tooltip: 'Ver historial',
              onClick: (event, rowData) => detallePaciente(rowData)
         
            },
          ]}
          options={{
            exportButton: true,
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: '#23272A',
              color: '#FFFFFF'
            },
            rowStyle: {
              backgroundColor: '#EEE',
              fontSize: '16px',
              // Added for custom with column,
              overflowWrap: 'break-word'
            },
          }}
          localization={{
            header:{  
              actions: "Acciones"
            },
            body: {
              emptyDataSourceMessage: (
                <CircularProgress />
              ),
            toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar"
            },
          },
            
          }}
        />

       </div>

          <Modal
          open={modalInsertar}
          onClose={abrirCerrarModalInsertar}>
            {bodyInsertar}
          </Modal>
  
          
          <Modal
          open={modalEditar}
          onClose={abrirCerrarModalEditar}>
            {bodyEditar}
          </Modal>
  
          <Modal
          open={modalEliminar}
          onClose={abrirCerrarModalEliminar}>
            {bodyEliminar}
          </Modal>
  
          {/* <Modal open={modalVer} onClose={abrirCerrarModalVer}>
            {bodyVer}
          </Modal> */}

      </div>
  
     );
}
 
export default Patients;